/* istanbul ignore file */
import RegisterGuarantors from './RegisterGuarantors';

export default RegisterGuarantors;
